export default __webpack_public_path__ + "static/media/logo.403b5c14.svg";